import { Component, computed, inject, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { UserService } from '../../../../services/user.service';
import { passwordMatchValidator } from '../../../../validators/password-match.validator';
import { AuthButtonComponent } from '../../../molecules/auth-button/auth-button.component';
import { InputComponent } from '../../../atoms/input/input.component';
import { AuthTemplateComponent } from '../../../organisms/auth-template/auth-template.component';
import { messages } from '../../common/register/register.constants';
import { descriptions, titles } from './set-password.constants';
import { RoutesEnum } from '../../../../enums/routes.enum';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  imports: [AuthTemplateComponent, FormsModule, InputComponent, AuthButtonComponent],
})
export class SetPasswordComponent implements OnInit {
  protected RequestStateEnum = RequestStateEnum;
  public messagesObject = messages;

  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private userService = inject(UserService);

  public token: string | null = null;
  public title: Signal<string> = computed(() => this.updateTitle());
  public desciption: Signal<string> = computed(() => this.updateDescription());
  public requestState: WritableSignal<RequestStateEnum | null> = signal(null);
  public form = new FormGroup(
    {
      password: new FormControl<string>('', Validators.required),
      confirmPassword: new FormControl<string>('', Validators.required),
    },
    {
      validators: passwordMatchValidator('password', 'confirmPassword'),
    }
  );

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('token');

    if (!this.token) {
      this.router.navigateByUrl(RoutesEnum.COMMON_LOGIN);
    }
  }

  public get showForm(): boolean {
    return this.requestState() === RequestStateEnum.PENDING || this.requestState() === null;
  }

  public setPassword(): void {
    this.requestState.set(RequestStateEnum.PENDING);
    this.form.disable();

    this.userService
      .setPassword(this.form.controls.password.value!, this.token!)
      .pipe(
        catchError(() => {
          this.requestState.set(RequestStateEnum.ERROR);
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.requestState.set(RequestStateEnum.SUCCESS);
      });
  }

  public goToLogin(): void {
    void this.router.navigateByUrl(RoutesEnum.COMMON_LOGIN);
  }

  private updateDescription(): string {
    switch (this.requestState()) {
      case RequestStateEnum.PENDING:
        return descriptions.pending;

      case RequestStateEnum.SUCCESS:
        return descriptions.success;

      case RequestStateEnum.ERROR:
        return descriptions.error;

      default:
        return descriptions.default;
    }
  }

  private updateTitle(): string {
    switch (this.requestState()) {
      case RequestStateEnum.ERROR:
        return titles.error;

      case RequestStateEnum.SUCCESS:
        return titles.success;

      default:
        return titles.default;
    }
  }
}
